import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ButtonComponent } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-accessory-info-dialog',
  imports: [ApmTranslatePipe, ButtonComponent],
  templateUrl: './accessory-info-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessoryInfoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AccessoryInfoDialogComponent>
  ) {}

  closeDialog() {
    this.dialogRef.close(undefined);
  }
}
